import { v4 as uuidv4 } from "uuid";

const token = localStorage.getItem('token') || localStorage.setItem('token', uuidv4()) || localStorage.getItem('token');

export { token }